import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import { useRecoilValue } from 'recoil';
import { useHippoText } from '../../../../hooks/useHippoText';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { RadioField, RadioInput } from '@flos/react-ui';
import { useState } from 'react';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import { track } from '../../../../utils/trackingUtil';
import type {
    ClaimsHistoryInformationToUpdateDTO,
    CoverableInformationToUpdateDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { COVERABLE_CODE } from '../../../../constants/coverable';
import { useSaveClaimsHistoryInformation } from '../../../../hooks/useSaveClaimsHistoryInformation';
import { claimsHistorySelector } from '../../../../recoil/selectors/claimsHistorySelector';

const HouseBuyingAHouseStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const shouldSendClaimsHistory = useRecoilValue(claimsHistorySelector);
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const { saveClaimsHistoryInformation } = useSaveClaimsHistoryInformation();
    const houseCoverables =
        currentProduct.flavourCode === COVERABLE_CODE.prhHouse
            ? coverables.houses ?? []
            : coverables.holidayHomes ?? [];
    const coverableIndex = houseCoverables?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const currentHouseCoverable = houseCoverables[coverableIndex];

    const [isLoading, setIsLoading] = useState(false);

    const handleChoiceChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        updateCoverableInformation({
            buyingHouse: event.target.value
        });
    };

    const onNext = (): void => {
        setIsLoading(true);
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            [currentProduct.flavourCode === COVERABLE_CODE.prhHouse ? 'house' : 'holidayHome']: {
                publicId: currentHouseCoverable.publicId,
                fixedId: currentHouseCoverable.fixedId,
                buyingHouse: currentHouseCoverable.buyingHouse === 'Ja'
            },
            productToUpdate: currentProduct.flavourName
        };

        if (currentHouseCoverable.buyingHouse === 'Ja' && shouldSendClaimsHistory) {
            const emptyClaim: ClaimsHistoryInformationToUpdateDTO = {
                [currentProduct.flavourName === 'Husforsikring' ? 'house' : 'holidayHome']: {
                    fixedId: currentHouseCoverable.fixedId,
                    numberOfClaims: 0
                },
                productToUpdate: currentProduct.flavourName
            };
            void saveClaimsHistoryInformation(emptyClaim).then(() => {
                const houseFlavour =
                    currentProduct.flavourName === 'Husforsikring' ? 'house' : 'holidayHome';
                track(`${houseFlavour}CoverableInformationNumberOfClaims`, [
                    {
                        numberOfClaims: 0
                    }
                ]);
            });
        }

        void saveCoverableInformation(updatedCoverable).then(() => {
            setIsLoading(false);
            track(`${currentProduct.flavourName}CoverableInformationBuyingAHouseStep`, [
                {
                    buyingHouse: currentHouseCoverable.buyingHouse
                }
            ]);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            disableNext={isLoading || currentHouseCoverable.buyingHouse === undefined}
            onPrevious={goPrevious}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-BUYING-A-HOUSE-HEADER')}
            >
                <RadioField
                    value={currentHouseCoverable.buyingHouse ?? ''}
                    onChange={handleChoiceChange}
                >
                    <RadioInput
                        label={getHippoText('DSS-COVERABLE-INFORMATION-STEP-BUYING-A-HOUSE-YES')}
                        value="Ja"
                    />
                    <RadioInput
                        label={getHippoText('DSS-COVERABLE-INFORMATION-STEP-BUYING-A-HOUSE-NO')}
                        value="Nej"
                    />
                </RadioField>
            </CoverableDetailsTemplate>
        </WizardPagetemplate>
    );
};

export default HouseBuyingAHouseStep;
